import { useState } from "react";
import parent1 from "../Assests/Testimonials/Parent1.jpg"
import parent2 from "../Assests/Testimonials/parent2.jpeg"
import parent3 from "../Assests/Testimonials/Parent5.png"
import Parent4 from "../Assests/Testimonials/Parent4.png"
import Parent5 from "../Assests/Testimonials/SDS_0001.JPG"
const testimonials = [
  {
    name: "CHANDRAWALI KALITA",
    role: "Family Member",
    rating: 5,
    quote:
      "School is good. All the members understand our issues and try to resolve if any. Mainly takes good care of my kids.",
    image: parent1,
  },
  {
    name: "cs reddy",
    role: "Parent",
    rating: 5,
    quote:
      "Seekers Bay Pre-School is a wonderful place for kids to learn and grow. The teachers are caring, patient, and always supportive. The activities are creative and engaging, helping children build confidence and skills..Thanks to seekers bay pre school Teacher and Management",
    image: parent2,
  },
  {
    name: "Sanchit Pandey",
    role: "Parent",
    rating: 5,
    quote:
      "We are really happy with the school's balanced approach towards academics and extracurricular activities. The curriculum is thoughtfully designed, encouraging creativity and critical thinking in children. Regular sports events and physical activities have helped build my child's confidence and team spirit.We've seen noticeable improvement in their understanding, behavior, and overall growth-thank you for your continuous efforts.",
    image: parent3,
  },
  {
    name: "Ravindra Patel",
    role: "Parent",
    rating: 5,
    quote:
      "Seekers Bay Pre-School is a wonderful place for kids to learn and grow. The teachers are caring, patient, and always supportive. The activities are creative and engaging, helping children build confidence and skills in a fun way. I am really happy with the care and attention given to each child. A big thank you to the whole team!",
    image: Parent4,
  },
  {
    name: "Shrikant Khapare",
    role: "Parent",
    rating: 5,
    quote:
    "Seekers Bay is an excellent preschool that truly focuses on the overall development and well-being of every child. The teachers are wonderful -caring, patient, and deeply committed to helping kids learn and grow in a happy environment. Each class has two teachers for about twelve children, which ensures every child gets personal attention.",
    image: Parent5,
  }
];

const partners = [
  { name: "EduStar", icon: "★" },
  { name: "KidsCare", icon: "◆" },
  { name: "PlayLearn", icon: "⚡" },
  { name: "BrightPath", icon: "◆" },
  { name: "NurtureHub", icon: "⚡" },
  { name: "GrowWise", icon: "✦" },
];

const StarIcon = ({ filled }) => (
  <svg
    className={`w-4 h-4 ${filled ? "text-orange-500" : "text-gray-300"}`}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const GoogleLogo = () => (
  <svg viewBox="0 0 48 48" className="w-10 h-10">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    <path fill="none" d="M0 0h48v48H0z"/>
  </svg>
);

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  const t = testimonials[current];

  return (
    <section
      className="w-full overflow-hidden"
      style={{
        background: "#f5f0e8",
        backgroundImage: `radial-gradient(circle at 10% 20%, rgba(249,115,22,0.06) 0%, transparent 40%), radial-gradient(circle at 80% 80%, rgba(16,185,129,0.04) 0%, transparent 40%)`,
        fontFamily: "'Nunito', sans-serif",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800;900&display=swap');
        .dot-bg {
          background-image: radial-gradient(circle, rgba(0,0,0,0.07) 1px, transparent 1px);
          background-size: 22px 22px;
        }
        .nav-btn {
          transition: all 0.2s ease;
        }
        .nav-btn:hover {
          background: #111827;
          color: white;
          transform: scale(1.08);
        }
        .review-card {
          transition: all 0.4s ease;
        }
        .partner-item {
          transition: all 0.2s ease;
        }
        .partner-item:hover {
          opacity: 1 !important;
          transform: translateY(-2px);
        }
        @keyframes fadeSlide {
          from { opacity: 0; transform: translateX(18px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        .fade-slide { animation: fadeSlide 0.4s ease forwards; }
        @keyframes marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .marquee-track { animation: marquee 18s linear infinite; }
      `}</style>

      {/* ── Testimonials ── */}
      <div className="dot-bg px-4 md:px-12 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          {/* Desktop layout */}
          <div className="hidden md:grid grid-cols-2 gap-10 items-start">

            {/* LEFT */}
            <div className="flex flex-col justify-between h-full">
              {/* Label */}
              <div>
                <span
                  className="inline-flex items-center gap-2 text-sm font-700 px-4 py-1.5 rounded-full mb-6"
                  style={{ background: "rgba(249,115,22,0.1)", color: "#f97316", border: "1px solid rgba(249,115,22,0.2)" }}
                >
                  <span className="text-orange-500">✦</span> Testimonials
                </span>
                <h2
                  className="text-4xl md:text-5xl font-900 leading-tight mb-8"
                  style={{ color: "#111827", fontWeight: 900 }}
                >
                  Hear what our happy<br />parents are saying
                </h2>
              </div>

              {/* Nav arrows */}
              <div className="flex gap-3 mb-10">
                <button
                  onClick={prev}
                  className="nav-btn w-11 h-11 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 cursor-pointer"
                  aria-label="Previous"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/>
                  </svg>
                </button>
                <button
                  onClick={next}
                  className="nav-btn w-11 h-11 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 cursor-pointer"
                  aria-label="Next"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/>
                  </svg>
                </button>
              </div>

              {/* Divider */}
              <div className="border-t border-gray-200 mb-6" />

              {/* Google rating */}
              <div className="flex items-center gap-4">
                <GoogleLogo />
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-2xl font-900 text-gray-900">4.9/5</span>
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} filled={true} />)}
                    </div>
                  </div>
                  <p className="text-sm text-gray-500 mt-0.5">Based on 250 review</p>
                </div>
              </div>
            </div>

            {/* RIGHT — card */}
            <div
              key={current}
              className="fade-slide rounded-2xl overflow-hidden shadow-xl"
              style={{ background: "white" }}
            >
              {/* Photo */}
              <div className="relative">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-full h-64 object-cover object-top"
                />
              </div>

              {/* Review */}
              <div className="p-7">
                <div className="flex gap-0.5 mb-4">
                  {[...Array(t.rating)].map((_, i) => <StarIcon key={i} filled={true} />)}
                </div>
                <p className="text-gray-700 text-base leading-relaxed mb-6 font-500">
                  "{t.quote}"
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-800 text-gray-900">{t.name}</p>
                    <p className="text-sm text-gray-500">{t.role}</p>
                  </div>
                  <span className="text-5xl text-orange-400 leading-none font-serif select-none">"</span>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile layout */}
          <div className="md:hidden">
            {/* Heading */}
            <h2 className="text-3xl font-900 text-gray-900 leading-tight mb-6" style={{ fontWeight: 900 }}>
              Hear what our happy parents are saying
            </h2>

            {/* Google rating */}
            <div className="flex items-center gap-3 mb-8">
              <GoogleLogo />
              <div>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-900 text-gray-900">4.9/5</span>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} filled={true} />)}
                  </div>
                </div>
                <p className="text-xs text-gray-500">Based on 250 review</p>
              </div>
            </div>

            {/* Card */}
            <div key={current} className="fade-slide rounded-2xl overflow-hidden shadow-lg bg-white mb-6">
              <img
                src={t.image}
                alt={t.name}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-5">
                <div className="flex gap-0.5 mb-3">
                  {[...Array(t.rating)].map((_, i) => <StarIcon key={i} filled={true} />)}
                </div>
                <p className="text-gray-700 text-sm leading-relaxed mb-4">"{t.quote}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-800 text-gray-900">{t.name}</p>
                    <p className="text-xs text-gray-500">{t.role}</p>
                  </div>
                  <span className="text-4xl text-orange-400 leading-none font-serif">"</span>
                </div>
              </div>
            </div>

            {/* Nav */}
            <div className="flex gap-3 justify-center">
              <button onClick={prev} className="nav-btn w-10 h-10 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 cursor-pointer">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"/>
                </svg>
              </button>
              <button onClick={next} className="nav-btn w-10 h-10 rounded-full border border-gray-300 bg-white flex items-center justify-center text-gray-600 cursor-pointer">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Awards & Achievements marquee ── */}
      {/* <div
        className="border-t border-b py-8"
        style={{ borderColor: "rgba(0,0,0,0.08)", background: "rgba(255,255,255,0.5)" }}
      >
        <p className="text-center text-xs tracking-widest text-gray-400 uppercase mb-6 font-600">
          Award &amp; Achievements
        </p>
        <div className="overflow-hidden relative">
          <div className="absolute left-0 top-0 bottom-0 w-16 z-10" style={{ background: "linear-gradient(to right, rgba(245,240,232,0.95), transparent)" }} />
          <div className="absolute right-0 top-0 bottom-0 w-16 z-10" style={{ background: "linear-gradient(to left, rgba(245,240,232,0.95), transparent)" }} />

          <div className="marquee-track flex items-center gap-12 whitespace-nowrap" style={{ width: "max-content" }}>
            {[...partners, ...partners].map((p, i) => (
              <div
                key={i}
                className="partner-item flex items-center gap-2 opacity-60 cursor-default"
              >
                <span
                  className="w-9 h-9 rounded-full flex items-center justify-center text-white text-base font-bold"
                  style={{ background: "#f97316" }}
                >
                  {p.icon}
                </span>
                <span className="text-lg font-800 text-gray-800">{p.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div> */}
    </section>
  );
}